// extracted by mini-css-extract-plugin
export default {"footer":"Seventh_footer__CxTRt"};